export default "__VITE_ASSET__CBHrPphD__"